// extracted by mini-css-extract-plugin
export default {"banner":"how-to_banner__MRznJ","content":"how-to_content__GN6lG","inline-code":"how-to_inline-code__lIZk0","list":"how-to_list__4ORid","pseudo-link":"how-to_pseudo-link__40DiR"};